import { ListItem, ListItemButton, ListItemIcon, Typography } from "@mui/material";
import type { ReactNode } from "react";
import CollapseMediumIcon from "@entrilia/shared/icons/CollapseMediumIcon";
import ExpandMediumIcon from "@entrilia/shared/icons/ExpandMediumIcon";

interface Props {
  title: string;
  open: boolean;
  onToggle: () => void;
  actions?: ReactNode;
}

const FieldsSectionHeader = ({ title, open, onToggle, actions }: Props) => (
  <ListItem
    component="div"
    disablePadding
    sx={{ height: 30, borderRadius: "2px", "&:hover, &:focus-within": { bgcolor: "action.hover" } }}
  >
    <ListItemButton
      aria-expanded={open}
      onClick={onToggle}
      sx={{ height: "100%", p: 0, minWidth: 0, "&:hover": { bgcolor: "transparent" } }}
    >
      <ListItemIcon sx={{ minWidth: "30px", justifyContent: "center", color: "secondary.main" }}>
        {open ? <CollapseMediumIcon /> : <ExpandMediumIcon />}
      </ListItemIcon>
      <Typography variant="subtitle2" color="textPrimary">
        {title}
      </Typography>
    </ListItemButton>
    {actions}
  </ListItem>
);

export default FieldsSectionHeader;
